export const FIRST_PAGE_KEY = 'first'

export function pageCacheIdentity({ country, query, onlyWithContracts }) {
  return [country ?? '', String(query ?? '').trim(), onlyWithContracts ? '1' : '0'].join('|')
}

export function pageCacheKey(cursor) {
  return cursor || FIRST_PAGE_KEY
}
